module.exports = __webpack_public_path__ + "static/media/flavour-anis.dfac8d01.png";